/**
 * AG Grid Community Setup
 *
 * Registers AG Grid Community modules. Must be called once before
 * any AG Grid instance is created (typically at app startup).
 *
 * Temporary: using Community until Enterprise license is added.
 * To switch back, replace AllCommunityModule with AllEnterpriseModule
 * from 'ag-grid-enterprise' and restore the license key call.
 */

import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

let initialized = false;

export function initializeAgGrid(): void {
  if (initialized) return;
  ModuleRegistry.registerModules([AllCommunityModule]);
  initialized = true;
}
